/**
 * Pure base64 ⇄ Blob helpers. Kept dependency-free (no Supabase / api client
 * imports) so lightweight modules — e.g. the flow-image codecs — can use it
 * without dragging the whole API layer into their import graph.
 */

/** Convert a base64 data URI (or raw base64) to a Blob. */
export function base64ToBlob(base64: string): Blob {
  const match = base64.match(/^data:([^;]+);base64,(.+)$/);
  const mime = match ? match[1] : "image/png";
  const raw = match ? match[2] : base64;
  let binary: string;
  try {
    binary = atob(raw);
  } catch {
    // `atob` throws a raw DOMException (InvalidCharacterError) on malformed
    // input. Surface a clear, typed Error so callers can detect and handle it
    // (we don't swallow it here — callers decide whether to drop the entry).
    throw new Error("Invalid base64 image data");
  }
  const array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }
  return new Blob([array], { type: mime });
}
